import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { usersActions } from '../slice';
import { selectUsers, selectUsersError, selectUsersIsLoading, selectUsersTotal } from '../slice/selectors';
import { selectCurrentProduct } from '../../../layouts/MainLayout/slice/selectors';

type Params = {
  query?: string;
};

export function useUsersList({ query }: Params) {
  const dispatch = useDispatch();
  const users = useSelector(selectUsers);
  const total = useSelector(selectUsersTotal);
  const isLoading = useSelector(selectUsersIsLoading);
  const error = useSelector(selectUsersError);
  const currentProduct= useSelector(selectCurrentProduct);
  const [pageIndex, setPageIndex] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);


  const requestIfNeeded = React.useCallback(() => {
    dispatch(
      usersActions.fetchUsersRequested({
        productId: currentProduct ?? null,
        page: pageIndex + 1,
        limit: rowsPerPage,
        skip: pageIndex * rowsPerPage,
        query: query?.trim() ? query.trim() : undefined,
      }),
    );
  }, [currentProduct, dispatch, pageIndex, query, rowsPerPage]);

  const reload = React.useCallback(() => {
    dispatch(
      usersActions.fetchUsersRequested({
        productId: currentProduct ?? null,
        page: pageIndex + 1,
        limit: rowsPerPage,
        skip: pageIndex * rowsPerPage,
        query: query?.trim() ? query.trim() : undefined,
        force: true,
      }),
    );
  }, [currentProduct, dispatch, pageIndex, query, rowsPerPage]);

  React.useEffect(() => {
    requestIfNeeded();
  }, [requestIfNeeded]);

  return { users, total, isLoading, error, reload, pageIndex, setPageIndex, rowsPerPage, setRowsPerPage, currentProduct };
}

